import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import ConveyorEditor from './ConveyorEditor';
import { useNavigate } from '../../../node_modules/react-router-dom/dist/index';
import { changeField, initialize } from '../../modules/conveyor/conveyorWriteSlice';
import AskConfirmModal from './AskConfirmModal';

const ConveyorEditorContainer = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const project = useSelector((state) => state.project.project);
    const title = useSelector((state) => state.conveyorWrite.title);
    const lineQty = useSelector((state) => state.conveyorWrite.lineQty);
    const conveyorType = useSelector((state) => state.conveyorWrite.conveyorType);
    const applyCode = useSelector((state) => state.conveyorWrite.applyCode);
    const body = useSelector((state) => state.conveyorWrite.body);
    const tags = useSelector((state) => state.conveyorWrite.tags);
    const user = useSelector((state) => state.conveyorWrite.user);
    const isValidTension = useSelector((state) => state.conveyorWrite.isValidTension);

    // console.log('isValidTension : ', isValidTension);

    useEffect(() => {
        return () => {
            dispatch(initialize());
        };
    }, [dispatch]);
    
    const onChangeField = useCallback((payload) => {
        dispatch(changeField(payload));
    }, [dispatch]);
    
    const onBackToList = () => {
        navigate(-1);
    };

    /* 컨베이어를 저장하고 돌아온 리스트 화면에서 뒤로가기를 누르면 conveyorWrite에 아무런 정보가 없기 때문에 에러가 발생하게 된다. 
        리덕스에 conveyorWrite 정보가 없으면 즉, 제대로 된 루트로 이 화면에 들어온 것이 아니기 때문에 '리스트로 돌아가기' 버튼을 배치한다 */
    const [modal, setModal] = useState(false);

    const onCancel = () => {
        setModal(false);
        navigate(`/projects/${project?._id}/conveyors`);
    }

    const onConfirm = () => {
        setModal(false);
    }
    /* => 에러. 새로 쓸 때도 이 창이 뜨기 때문에 이렇게 하면 안된다. 아래와 같이 useEffect를 써서 해결함. */
    // if (!title) {
    //     return (
    //         <ButtonBackToList to={`/projects/${project._id}/conveyors`}>리스트로 돌아가기</ButtonBackToList>
    //     )
    // }

    useEffect(() => {
        if (!title) {
            setModal(true);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // 처음 로딩될 때만 실행되어야 하므로 (Title 작성하다가 다 지우면 모달창이 다시 뜨게 됨.) 디펜던시 배열을 비워둔다.


    return (
        <>
            <ConveyorEditor
                onChangeField={onChangeField}
                onBackToList={onBackToList}
                project={project}
                title={title}
                lineQty={lineQty}
                conveyorType={conveyorType}
                applyCode={applyCode}
                body={body}
                tags={tags}
                user={user}
                isValidTension={isValidTension}
            />
            <AskConfirmModal visible={modal} onConfirm={onConfirm} onCancel={onCancel} />
        </>
    );
};

export default ConveyorEditorContainer;
